"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var grid_model_1 = require("../../../model/layout/grid-model");
var interpreter_utils_1 = require("../../../interpreter-utils");
var layout_reader_1 = require("./layout-reader");
var row_model_reader_1 = require("./row-model-reader");
var grid_type_1 = require("../../../model/layout/grid-type");
var lodash_1 = require("lodash");
var GridModelReader = /** @class */ (function (_super) {
    __extends(GridModelReader, _super);
    function GridModelReader(properties, controlResolver, context) {
        return _super.call(this, 'grid', properties, controlResolver, context, new row_model_reader_1.RowModelReader(properties, controlResolver, context)) || this;
    }
    GridModelReader.prototype.readValue = function (value) {
        if (!lodash_1.isNil(value)) {
            var id = interpreter_utils_1.getOptionalProperty(value, 'id', interpreter_utils_1.uniqueId());
            return new grid_model_1.GridModel(id, interpreter_utils_1.getRequiredProperty(value, 'rows'), interpreter_utils_1.getOptionalProperty(value, 'type', grid_type_1.GridType.FLAT), this.properties.getGridProperties(id));
        }
        else {
            return grid_model_1.GridModel.empty();
        }
    };
    return GridModelReader;
}(layout_reader_1.LayoutReader));
exports.GridModelReader = GridModelReader;
//# sourceMappingURL=grid-model-reader.js.map